import React from 'react';
import { motion } from 'framer-motion';

const pasos = [
  { n: '01', t: 'Crea tu cuenta gratis', d: 'Regístrate en 2 minutos con el nombre de tu empresa. Sin tarjeta y con todo incluido durante 15 días.' },
  { n: '02', t: 'Añade a tu equipo', d: 'Da de alta empleados con horario genérico, distinto por cada día o heredado del centro. Configura turnos, cuadrantes semanales y calendarios festivos en pocos clicks.' },
  { n: '03', t: 'Fichan, tú recibes los informes', d: 'Kiosko en tablet, ordenador o app móvil con GPS y biometría. Programas los informes profesionales (semanal o mensual) y llegan solos a tu gestoría y RRHH. Cumples la ley 2026 sin tocar nada.' },
];

export const HowItWorks = () => (
  <section className="py-20 sm:py-28 bg-forest-100/50" data-testid="how-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, x: -24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6 }}
        className="relative order-2 lg:order-1"
      >
        <div className="rounded-3xl overflow-hidden border border-forest-900/10 shadow-[0_24px_60px_rgb(15,28,20,0.12)]">
          <img src="/landing/hero_office.webp" alt="Empleada fichando en la tablet kiosko en la recepción de la oficina" className="w-full block" loading="lazy" />
        </div>
        <div className="absolute -bottom-6 right-6 w-40 rounded-2xl overflow-hidden border border-forest-900/10 shadow-xl rotate-2 hidden sm:block">
          <img src="/landing/mobile_gps.webp" alt="Trabajador de campo fichando desde el móvil" className="w-full block" loading="lazy" />
        </div>
      </motion.div>
      <div className="order-1 lg:order-2">
        <p className="font-body-landing text-terracotta font-bold text-sm tracking-[0.15em] uppercase mb-4">Cómo funciona</p>
        <h2 className="font-display font-black text-forest-900 text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight mb-10">
          Hoy lo pruebas, mañana ya cumples
        </h2>
        <div className="space-y-8">
          {pasos.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="flex gap-6"
              data-testid={`how-step-${i}`}
            >
              <span className="font-display font-black text-terracotta/90 text-2xl shrink-0 pt-0.5">{p.n}</span>
              <div>
                <h3 className="font-display font-bold text-xl text-forest-900 mb-1.5">{p.t}</h3>
                <p className="font-body-landing text-forest-700 text-sm md:text-base leading-relaxed">{p.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
